export default function ProcessingSpeedsSection() {
  const cards = [
    {
      title: "3 Business Days",
      subtitle: "Most Urgent",
      desc: "Trip within the next week. Hand-courier with reserved agency slot. Overnight FedEx return.",
      price: "From $345",
      badge: null,
    },
    {
      title: "4 Business Days",
      subtitle: "Most Popular",
      desc: "Trip within 1–2 weeks. Priority submission, expedited processing.",
      price: "From $295",
      badge: "Most Popular",
    },
    {
      title: "7 Business Days",
      subtitle: "Reliable Expedited",
      desc: "Trip within about 2 weeks. Reliable expedited processing.",
      price: "From $245",
      badge: null,
    },
    {
      title: "9 Business Days",
      subtitle: "Faster Than Government",
      desc: "Trip 2–3 weeks out. Faster than government, lower price.",
      price: "From $195",
      badge: null,
    },
    {
      title: "3–5 Weeks",
      subtitle: "Smart Saver",
      desc: "Trip 3+ weeks out. Most affordable. Still faster than government alone.",
      price: null,
      badge: null,
    },
  ];

  return (
    <section className="py-14 md:py-20 bg-[#F7F7F5]">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-bold text-[#2D2D2D] mb-4">
            Choose Your Urgent Processing Speed
          </h2>
          <p className="text-base md:text-lg text-gray-600 max-w-3xl mx-auto">
            Every urgent situation is different. Pick the tier that fits your travel date.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cards.map((card, i) => (
            <div
              key={i}
              className={`bg-white rounded-lg border p-6 md:p-7 flex flex-col ${
                card.badge ? "border-amber-400 ring-1 ring-amber-400" : "border-gray-200"
              }`}
            >
              {card.badge && (
                <span className="self-start inline-block bg-amber-500 text-white text-xs font-bold px-3 py-1 rounded-full mb-3 whitespace-nowrap">
                  {card.badge}
                </span>
              )}
              <h3 className="text-xl font-bold text-[#2D2D2D] mb-1">{card.title}</h3>
              <p className="text-sm text-amber-700 font-semibold mb-3">{card.subtitle}</p>
              <p className="text-gray-600 text-sm leading-relaxed mb-5 flex-1">{card.desc}</p>
              {card.price && (
                <p className="text-2xl font-bold text-[#2D2D2D] mb-4">{card.price}</p>
              )}
              <a
                href="https://fastpassportcenter.com/checkout/"
                className={`whitespace-nowrap inline-flex items-center justify-center gap-2 px-6 py-3 font-semibold rounded-md transition-colors cursor-pointer text-sm ${
                  card.badge
                    ? "bg-amber-500 hover:bg-amber-600 text-white"
                    : "bg-[#2D2D2D] hover:bg-[#1a1a1a] text-white"
                }`}
              >
                <i className="ri-arrow-right-line"></i>
                Start Urgent Order
              </a>
            </div>
          ))}
        </div>

        <p className="text-center text-sm text-gray-500 mt-8 max-w-2xl mx-auto">
          Government fees are separate and paid to the U.S. Department of State. Our service fee covers document review, courier submission, and overnight return delivery.
        </p>
      </div>
    </section>
  );
}